// extracted by mini-css-extract-plugin
export default {"calendar":"Calendar_calendar__vKx+D","btn1":"Calendar_btn1__C4J8+","btn2":"Calendar_btn2__O1kNQ"};